import React, { useEffect, useState } from 'react';

import PurpleLoadingSpinner from '../../../../../assets/images/loading-spinner-purple.svg';
import { getDateRange } from '../../dashboard/cards/OpportunityCard';
import { MAP_IMG } from '../../../utils/contants';
import { findAssetFromOpportunityData } from '../../../utils';

export const OrganizationOpportunitesTab = ({
	orgID,
	opportunities,
	currentUserCanEdit,
	isFetchingOpportunities,
}) => {
	const [hasSavedDrafts, setHasSavedDrafts] = useState(false);
	const [hasPublishedOpportunities, setHasPublishedOpportunities] =
		useState(false);

	useEffect(() => {
		for (const opportunity of opportunities) {
			if (!opportunity.published) {
				setHasSavedDrafts(true);
			} else {
				setHasPublishedOpportunities(true);
			}
		}
	}, []);

	const redirectToCreateOpportunity = () => {
		location.assign(
			`/organizations/${orgID}/property_info/opportunities/new`
		);
	};

	if (isFetchingOpportunities) {
		return (
			<div style={{ textAlign: 'center' }}>
				<img
					id="purple-loading-spinner"
					src={PurpleLoadingSpinner}
					alt="Loading spinner"
				/>
			</div>
		);
	}

	if (opportunities?.length === 0) {
		return (
			<div className="opportunities-tab">
				{currentUserCanEdit ? (
					<div>
						<p className="body-font">
							Do you have an opportunity to share with potential
							sponsors?
						</p>
						<p className="body-font">
							Create your own page to allow for partnerships and
							connections to be made!
						</p>
						<div
							className="primary-button"
							onClick={redirectToCreateOpportunity}
						>
							<p>Create</p>
						</div>
					</div>
				) : (
					<div>
						<p>
							There doesn't seem to be any opportunities available
							to show yet, please check again at a later date!
						</p>
					</div>
				)}
			</div>
		);
	}

	return (
		<div className="opportunities-tab">
			{currentUserCanEdit ? (
				<div
					className="primary-button"
					onClick={redirectToCreateOpportunity}
				>
					<p>Create Opportunity</p>
				</div>
			) : (
				<></>
			)}

			{hasSavedDrafts && currentUserCanEdit ? (
				<div>
					<h6 className="header-font top-40px-margin">
						{' '}
						Saved Drafts{' '}
					</h6>

					<div style={{ display: 'flex', flexWrap: 'wrap' }}>
						{opportunities &&
							opportunities.map((opportunity, index) => {
								if (opportunity.published) {
									return;
								}

								return (
									<OpportunityPreview
										key={index}
										opportunity={opportunity}
									/>
								);
							})}
					</div>
				</div>
			) : (
				''
			)}

			{hasPublishedOpportunities ? (
				<h6 className="header-font top-40px-margin">
					Published Opportunities
				</h6>
			) : (
				''
			)}

			<div style={{ display: 'flex', flexWrap: 'wrap' }}>
				{opportunities &&
					opportunities.map((opportunity, index) => {
						if (!opportunity.published) {
							return;
						}

						return (
							<OpportunityPreview
								key={index}
								opportunity={opportunity}
							/>
						);
					})}
			</div>
		</div>
	);
};

const OpportunityPreview = ({ opportunity }) => {
	const date_range = getDateRange(
		opportunity?.timeframe_start_on,
		opportunity?.timeframe_end_on
	);

	let image_asset = findAssetFromOpportunityData('header_media', opportunity);

	if (!image_asset) {
		image_asset = findAssetFromOpportunityData('body_media_1', opportunity);
	}

	if (!image_asset) {
		image_asset = findAssetFromOpportunityData('body_media_2', opportunity);
	}

	const validated_image_asset =
		image_asset?.url ||
		(image_asset?.path
			? `https://res.cloudinary.com/sponsor-circle/image/upload/${image_asset?.path}`
			: null);

			
	return (
		<a
			href={`/organizations/${opportunity.organization_id}/property_info/opportunities/${opportunity.id}`}
			className="opportunity-preview-wrapper"
		>
			<div className="opportunity-preview-content-wrapper">
				<div className="opportunity-preview-content">
					<h3 className="ellipsis">{opportunity?.name}</h3>
					<p className="ellipsis">{date_range}</p>
					{opportunity.expected_audience && (
						<p className="opportunity-preview-point ellipsis">
							<b>Audience reach:</b>{' '}
							{opportunity?.expected_audience}
						</p>
					)}

					{opportunity.expected_impressions && (
						<p className="opportunity-preview-point ellipsis">
							<b>Total expected impressions:</b>{' '}
							{opportunity?.expected_impressions}
						</p>
					)}
					{opportunity?.primary_age_group && (
						<p className="opportunity-preview-point ellipsis">
							<b>Primary age of attendees:</b>{' '}
							{opportunity?.primary_age_group}
						</p>
					)}
					{opportunity?.gender && (
						<p className="opportunity-preview-point ellipsis">
							<b>Primary gender of attendees:</b>{' '}
							{opportunity?.gender}
						</p>
					)}
					{opportunity?.household_income && (
						<p className="opportunity-preview-point ellipsis">
							<b>Avg annual household income:</b>{' '}
							{opportunity?.household_income}
						</p>
					)}
				</div>
				<div className="opportunity-preview-image-wrapper">
					<img
						className="opportunity-preview-image"
						src={validated_image_asset || MAP_IMG}
					></img>
				</div>
			</div>
			<p className="opportunity-preview-text">
				{opportunity.description}
			</p>
		</a>
	);
};


